import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {InlineSVGModule} from "ng-inline-svg-2";
import {NgOptimizedImage} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  selector: 'crm-maintenance',
  standalone: true,
  imports: [
    InlineSVGModule,
    NgOptimizedImage
  ],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  private intervalId: ReturnType<typeof setInterval>;
  private readonly subscriptions: Subscription[]=[];

  constructor(private readonly http: HttpClient) {
  }

  ngOnInit() {
    // Ping /me every 10 seconds
    this.intervalId = setInterval(() => {
      this.subscriptions.push(
        this.http.get(environment.apiUrl + 'users/me').subscribe({
          next: () => {
          },
        }));
    }, 10000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.subscriptions.forEach((sub: Subscription) => {sub.unsubscribe();});
  }
}
